<!-- 由 suu 创建于 2023-01-10 星期二 -->
<template>
  <div class="coach-prove-2023">
    <img :src="$store.state.coachProve.bg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'coach-prove-2023',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.coach-prove-2023 {
  width: 100vw;
  min-height: 100vh;
  background-color: #919bf3;
  img {
    width: 100%;
    box-sizing: border-box;
    display: block;
  }
}
</style>
